import { Injectable } from '@angular/core';
import { DefaultService } from '@common/references/default.service';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ContractService extends DefaultService<any>{
  backendName: string = 'contract';

  getUrl(): string {
    return environment.apiUrl + '/contract';
  }
}
